import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/corner-right-up.svg'
import _imports_1 from '@/assets/img/Icons/Grey/Contact.svg'
import _imports_2 from '@/assets/img/Icons/Grey/Forward.svg'
import _imports_3 from '@/assets/img/Icons/round_star_gold.svg'
import _imports_4 from '@/assets/img/Icons/round_star_silver.svg'
import _imports_5 from '@/assets/img/Icons/round_star_bronze.svg'


const _withScopeId = n => (_pushScopeId("data-v-7bc86a21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Up one level",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "table-header left-align" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "table-header" }, null, -1))
const _hoisted_7 = { class: "body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "table-cell",
  colspan: "3"
}
const _hoisted_10 = { class: "loading" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  class: "table-cell",
  colspan: "3"
}
const _hoisted_13 = { class: "heading" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "table-cell" }
const _hoisted_16 = { class: "value-container" }
const _hoisted_17 = {
  key: 0,
  class: "",
  src: _imports_1,
  alt: "avatar"
}
const _hoisted_18 = {
  key: 1,
  class: "",
  src: _imports_2,
  alt: "group"
}
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "table-cell" }
const _hoisted_21 = {
  key: 0,
  src: _imports_3,
  alt: "gold"
}
const _hoisted_22 = {
  key: 1,
  src: _imports_4,
  alt: "silver"
}
const _hoisted_23 = {
  key: 2,
  src: _imports_5,
  alt: "bronze"
}
const _hoisted_24 = { class: "table-cell" }
const _hoisted_25 = { class: "nps-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortDirection = _resolveComponent("SortDirection")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_UpDownArrow = _resolveComponent("UpDownArrow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isRoot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "non-root",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
          }, [
            _hoisted_3,
            _createTextVNode(" Back to " + _toDisplayString(_ctx.name), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.viewByGroupTypeName), 1),
          _hoisted_6,
          _createElementVNode("th", {
            class: "table-header right-align",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSortDirection && _ctx.toggleSortDirection(...args)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.metrics) + " ", 1),
            _createVNode(_component_SortDirection, { direction: _ctx.sortDirection }, null, 8, ["direction"])
          ])
        ])
      ]),
      _createElementVNode("tbody", _hoisted_7, [
        (_ctx.isLoadingInsightsData)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Loading, {
                    inline: "",
                    transparent: "",
                    loading: ""
                  })
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.rows.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, " No " + _toDisplayString(_ctx.pluralizedViewByGroupTypeName.toLowerCase()) + " match your filters ", 1)
                    ])
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.rows, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.group,
                      onClick: ($event: any) => (_ctx.onClickRow(row))
                    }, [
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          (_ctx.isLeaf)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                            : (_openBlock(), _createElementBlock("img", _hoisted_18)),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(row.group), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        (_ctx.isGoldStatus(row.status))
                          ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                          : (_ctx.isSilverStatus(row.status))
                            ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                            : (_ctx.isBronzeStatus(row.status))
                              ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createTextVNode(_toDisplayString(_ctx.rowValue(row).formattedValue) + " ", 1),
                          _createVNode(_component_UpDownArrow, {
                            class: "arrow",
                            positive: _ctx.rowValue(row).delta >= 0
                          }, null, 8, ["positive"])
                        ])
                      ])
                    ], 8, _hoisted_14))
                  }), 128))
            ], 64))
      ])
    ])
  ]))
}